import keycloak from '../../../Keycloak';
import {nextcloud as axios} from '../../../axios';

export const enableDyslexic = async () => {
  const token = keycloak.token;

  return await axios.put(
    '/ocs/v2.php/apps/theming/api/v1/theme/opendyslexic/enable',
    undefined,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: '*/*',
      },
    },
  );
};

export const disableDyslexic = async () => {
  const token = keycloak.token;

  return await axios.delete(
    '/ocs/v2.php/apps/theming/api/v1/theme/opendyslexic',
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: '*/*',
      },
    },
  );
};

export const enableDarkMode = async () => {
  const token = keycloak.token;

  return await axios.put(
    '/ocs/v2.php/apps/theming/api/v1/theme/dark/enable',
    undefined,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: '*/*',
      },
    },
  );
};

export const enableLightMode = async () => {
  const token = keycloak.token;

  return await axios.put(
    '/ocs/v2.php/apps/theming/api/v1/theme/light/enable',
    undefined,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: '*/*',
      },
    },
  );
};
